import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '.maximize'
})
export class MaximizeDirective {
    @HostBinding('class.fullscreen') private _addfullScreen = false;

    constructor() { }

    addFullScreen(fullScreen: boolean) {
        this._addfullScreen = fullScreen;
    }

}
